function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M109.266,183.742c8.3-0.798,15.955-6.162,22.758-15.944c6.174-8.88,11.534-21.144,15.932-36.45 c4.336-15.101,6.718-29.61,7.952-39.123l0.755-5.819l5.861-2.76c11.938-5.624,23.967-17.795,28.582-22.765 c1.401-1.508,2.769-3.05,4.061-4.582c1.433-1.699,1.84-4.039,1.067-6.122c-0.772-2.085-2.607-3.591-4.801-3.944 c-5.968-0.96-12.598-1.229-17.956-0.715c-8.457,0.814-15.146,3.405-19.349,7.494l-6.026,5.874l-7.14-4.465 c-10.086-6.307-22.683-9.641-36.433-9.641c-2.818,0-5.707,0.142-8.586,0.419c-22.6,2.174-36.224,10.098-43.676,16.364l-5.37,4.518 l-7.005-3.471c-4.719-2.335-11-3.177-18.373-2.469c-6.997,0.672-13.366,2.613-17.477,4.123c-2.086,0.766-3.599,2.596-3.96,4.788 c-0.361,2.192,0.485,4.41,2.217,5.804c1.26,1.015,2.572,2.028,3.896,3.013C10.232,80.87,24.43,90.971,37.68,94.954l7.369,2.217 l1.766,5.26c2.917,8.691,7.769,21.846,14.326,35.159c7.308,14.832,14.978,26.363,22.794,34.275 c7.855,7.946,15.683,11.977,23.268,11.977C107.894,183.842,108.59,183.807,109.266,183.742z"
}), React.createElement("path", {
  d: "M426.168,155.353c-5.494-10.029-21.202-16.025-35.572-19.52c-6.795-15.568-22.868-26.54-41.573-26.54 c-2.428,0-4.905,0.196-7.371,0.584l-4.788,0.755l-3.732-3.098c-8.188-6.801-18.663-10.547-29.495-10.547 c-6.562,0-12.905,1.332-18.855,3.962l-4.331,1.916l-4.334-1.916c-5.95-2.629-12.295-3.962-18.858-3.962 c-10.157,0-19.752,3.17-27.746,9.167l-4.848,3.638l-5.617-2.279c-5.559-2.252-11.46-3.395-17.546-3.395 c-8.068,0-15.994,2.076-22.922,6.005l-1.708,0.97c-1.562,0.885-2.659,2.405-3.008,4.166c-1.521,7.676-3.301,15.081-5.287,22.008 c-5.044,17.562-11.415,31.953-18.938,42.773c-10.565,15.194-23.456,23.623-38.307,25.051l-0.423,0.039 c-2.083,0.184-3.933,1.41-4.91,3.259c-0.979,1.849-0.952,4.068,0.066,5.894c3.603,6.442,8.964,11.957,15.505,15.951l5.414,3.306 l-0.287,6.336c-0.029,0.654-0.053,1.32-0.053,1.991c0,13.981,7.174,26.772,18.427,34.724v65.295c0,6.894,5.607,12.5,12.5,12.5 s12.5-5.606,12.5-12.5v-51.723c5.601,8.15,13.675,14.09,23,17.126v63.665c0,6.894,5.607,12.5,12.5,12.5s12.5-5.606,12.5-12.5 v-62.527c2.915-0.662,5.765-1.596,8.524-2.819l5.511-2.445l4.952,3.437c7.718,5.354,16.84,8.184,26.381,8.184 c7.961,0,15.794-2.023,22.65-5.855l5.228-2.922l5.229,2.92c6.393,3.569,13.628,5.549,21.024,5.807v27.156 c0,6.894,5.606,12.5,12.5,12.5c6.893,0,12.5-5.606,12.5-12.5v-33.355c3.44-2.014,6.632-4.48,9.482-7.393l3.129-3.195l4.475-0.023 c1.148-0.008,2.286-0.068,3.414-0.156v73.192c0,6.894,5.606,12.5,12.5,12.5c6.893,0,12.5-5.606,12.5-12.5v-82.948 c9.982-7.918,16.359-19.863,16.359-33.17c0-7.502-2.058-14.898-5.948-21.396l-3.307-5.513l3.307-5.515 c3.892-6.493,5.948-13.892,5.948-21.393c0-9.944-3.447-19.291-9.97-27.027l-3.711-4.404l0.509-1.734 c9.862,7.605,21.318,15.301,28.704,11.531c2.539-1.297,4.655-3.811,6.287-7.474C428.926,165.909,428.898,160.338,426.168,155.353z "
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgCordeiro = function SvgCordeiro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "428.236px",
    height: "428.237px",
    viewBox: "0 0 428.236 428.237",
    style: {
      enableBackground: "new 0 0 428.236 428.237"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCordeiro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cordeiro.fdeccb6b.svg";
export { ForwardRef as ReactComponent };